import type { PILOT_COMPONENTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-components-card/pilot-components-card.fr.ts";

export const PILOT_COMPONENTS_CARD_ENGLISH_LOCALE = {
  title: "Pilot components",
} satisfies typeof PILOT_COMPONENTS_CARD_FRENCH_LOCALE;
